import { useTranslation } from "react-i18next";

const PartialTransport = () => {
  const { t } = useTranslation();
  return (
    <main className="py-20 ">
      <div className="w-11/12 mx-auto space-y-10">
        <section>
          <h1 className="font-semibold text-[32px] text-center pb-10 ">
            {t("partialTransport")}
          </h1>
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("partialTransportRefers")}
          </h2>
          <p className=" text-[18px]">{t("thisTypeOFTransport")}</p>
        </section>
        <section className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/partialTransport1.jpg"
            alt="partial transport 1"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/partialTransport2.jpg"
            alt="partial transport 2"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/partialTransport3.jpg"
            alt="partial transport 3"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/partialTransport1.jpg"
            alt="partial transport 4"
          />
        </section>
        {/* Partial Shipping */}
        <section className="bg-white shadow-md rounded-2xl p-9">
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("partialShipping")}
          </h2>
          <p>{t("megtlogisticsPartialShipping")}</p>
          {/* What is Partial Shipping*/}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("whatIsPartialShipping")}
          </h3>
          <p>{t("serviceDefinition")}</p>
          {/* Coverage */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("megtlogisticsGeographical")}
          </h3>
          <p>{t("megtlogisticsOffersService")}</p>
          {/* Available Methods */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("availableMethods")}
          </h3>
          <h4 className="my-4">{t("megtlogisticsProvidesMultipleOptions")}</h4>
          <h4 className="text-mainBlue">{t("landTransport")}</h4>
          <p className="mb-4">{t("advantagesIdeal")}</p>
          <h4 className="text-mainBlue">{t("2seaFreight")}</h4>
          <p className="mb-4">{t("advantagesTheBestOption")}</p>
          <h4 className="text-mainBlue">{t("3airFreight")}</h4>
          <p className="mb-4">{t("advantagesTheFastest")}</p>
          {/* Benefits */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("benefitsOfPartialShipping")}
          </h3>
          <p className="my-4">
            <span className="text-mainBlue">{t("costEfficiency")}</span>
            {t("noNeedToBookFull")}
          </p>
          <p className="my-4">
            <span className="text-mainBlue">{t("comprehensiveSolutions")}</span>
            {t("inAdditionToShipping")}
          </p>
          <p className="my-4">
            <span className="text-mainBlue">{t("optimalSelection")}</span>
            {t("dependingOnCargoType")}
          </p>
          {/* How to Benefit */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("howToBenefit")}
          </h3>
          <h4 className="text-mainBlue">{t("iInitialConsultation")}</h4>
          <p className="mb-4">{t("megtlogisticsTeamEvaluates")}</p>
          <h4 className="text-mainBlue">{t("choosingMethod")}</h4>
          <p className="mb-4">{t("basedOnDeliveryTime")}</p>
          <h4 className="text-mainBlue">{t("shipmentExecution")}</h4>
          <p className="mb-4">{t("allLogisticsProcedures")}</p>
          {/* Conclusion */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">{t("conclusion")}</h3>
          <p>{t("partialShippingWithMegtlogistics")}</p>
        </section>
      </div>
    </main>
  );
};

export default PartialTransport;
